<script lang="ts" generics="T">
	export let id: string;
	export let name: string;
	export let value: T;
	export let group: T;
	export let disabled = false;
	export let required = false;
	export let note = false;
	export let noteName: string | undefined = undefined;
	export let notePlaceholder: string | undefined = undefined;

	$: checked = group === value;
</script>

<label
	for={id}
	class="flex h-[3.5rem] w-full justify-between rounded-[.25rem] {disabled
		? 'cursor-not-allowed'
		: 'cursor-pointer'} {checked
		? 'border-secondary border-2 px-3 py-[0.875rem] lg:px-6'
		: 'border-secondary-250 border px-[calc(0.75rem+1px)] py-[calc(0.875rem+1px)] lg:px-[calc(1.5rem+1px)]'}
		{checked && note ? 'h-auto flex-col' : ''}"
>
	<div class="flex w-full items-center gap-3">
		<input class="accent-secondary" {id} {name} type="radio" {value} {required} bind:group on:change {disabled} />
		<span
			class="flex w-full items-center gap-3 text-xs leading-[1.2] lg:gap-4 lg:text-base {checked
				? 'text-secondary font-semibold'
				: ''}"
			class:text-grey-300={disabled}
		>
			<slot />
		</span>
	</div>
	{#if checked && note}
		<div class="relative mt-4 w-full">
			<textarea
				id={noteName}
				name={noteName}
				class="input-with-label peer h-[15.5625rem] w-full resize-none rounded-[.25rem] border border-gray-200 px-3 !pb-4 !pt-[2.25rem] text-base focus:font-semibold focus:outline-none lg:px-6"
				placeholder=" "
			></textarea>
			<label class="label textarea-label" for={noteName}>{notePlaceholder}</label>
		</div>
	{/if}
</label>
